import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
	name: 'lineBreak',
	pure: true,
})
export class LineBreakPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {}

	transform(value: string[] | any): string {
		let dirtyString: string;

		if (Array.isArray(value)) {
			dirtyString = value.join('<br/>');
		} else {
			dirtyString = value?.toString();
		}
		return this.sanitizer.sanitize(SecurityContext.HTML, dirtyString);
	}
}
